import api from './api'

const transactionService = {
  getList: (params = {}) =>
    api.get('/api/v1/transactions', { params }).then(r => r.data),

  getById: (id) =>
    api.get(`/api/v1/transactions/${id}`).then(r => r.data),

  getRelated: (id) =>
    api.get(`/api/v1/transactions/${id}/related`).then(r => r.data),

  // BUG 4 FIX: addComment returns full updated transaction so caller can
  // update local state optimistically without needing a re-fetch
  addComment: (id, comment) =>
    api.post(`/api/v1/transactions/${id}/comments`, { comment }).then(r => r.data),

  manualDecision: (id, decision) =>
    api.post(`/api/v1/transactions/${id}/decision`, { decision }).then(r => r.data),

  exportCsv: (params = {}) =>
    api.get('/api/v1/transactions/export', { params, responseType: 'blob' }).then(r => r.data),
}

export default transactionService
